var endlessScroll;

jQuery(document).on('facets:rerendered', function () {
  var limiterControl = jQuery(document).find('.limiter__control');
  
  if (limiterControl.attr('data-current-limit') === 'all') {
    endlessScroll = new Ajaxinate({
        container: '#productsContainerScroll',
        pagination: '#infinitePagination',
        loadingText: 'Loading...'
    });
  } else {
    if(typeof endlessScroll === 'object' && typeof endlessScroll.destroy === 'function') {
      endlessScroll.destroy();
    }
  }
})

jQuery(document).on('click', '.per__page-control', function(){
  var val = jQuery(this).attr('data-val'),
    category = window.location.pathname.replace('/collections/', ''),
    url = new URL(window.location.href);

  url.searchParams.set("pageLimit", val);
  localStorage.setItem("navigated:by:link", false);
  history.replaceState({}, "", url);

  jQuery.ajax({
    type: "POST",
    url: '/cart.js',
    data: {"attributes[pagination]": category + ':' + val},
    success: function(){
      jQuery(document).trigger('pagination--limit');  
    },
      dataType: 'json'
  });
});

jQuery(document).ready(function(){
  var url = new URL(window.location.href),
      pageLimit = url.searchParams.get("pageLimit"),
      category = window.location.pathname.replace('/collections/', '');
  
  if (document.referrer === '' && pageLimit) {
    localStorage.setItem("navigated:by:link", true);
    
    jQuery.ajax({
        type: "POST",
        url: '/cart.js',
        data: {"attributes[pagination]": category + ':' + pageLimit},
        success: function(){
          jQuery(document).trigger('pagination--limit');  
        },
        dataType: 'json'
    });
  }
});